/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from 'react';
import Tag from "components/cong-dong/chi-tiet/image-tag";
import isEmpty from 'lodash/isEmpty';

export default function SlideImage({ image: imageP, isCreate = false }) {
    const [isTagDisplay, setIsTagDisplay] = useState(true);
    const [tagShowingId, setTagShowingId] = useState(null);
    const [image, setImage] = useState(imageP);

    useEffect(() => {setImage(imageP);}, [imageP]);
    const switchTagEnable = () => {
        setIsTagDisplay(!isTagDisplay);
    };

    return (
        <>
            <div className="photoGallery-large">
                <img src={image.storage_url} alt="" />
                {!isCreate && <div className="photoGallery-switch">
                    <div className="switch">
                        <label className="switch-label">
                            <input className={isTagDisplay ? "switch-checkbox active" : "switch-checkbox"} value={isTagDisplay} onChange={switchTagEnable} type="checkbox" />
                            <span className="switch-round"></span>
                        </label>
                    </div>
                </div>}
                {isTagDisplay && image['tagged_products'].map((tag, index) => {
                    if (isEmpty(tag.position)) return <></>;
                    return <Tag key={`${image.id}` + index} tag={tag} tagShowingId={tagShowingId} setTagShowingId={setTagShowingId} />;
                })}
            </div>
        </>
    );
};